export const legacyPhotoScheduleGroups = [{ id: 'mock-group', name: 'Mock 그룹' }]
export const legacyPhotoScheduleOffices = [{ id: 'mock-office', name: 'Mock 지점' }]
export const legacyPhotoScheduleRows = Array.from({ length: 4 }, (_, index) => ({
  id: `MOCK-SCHEDULE-${index + 1}`, no: index + 1, date: '0000-00-00', time: '00:00', product: `Mock 이전상품 ${index + 1}`,
  workgroup: 'Mock 작업팀', customerNo: `MOCK-${index + 1}`, oldNo: '-', baby: '아기◯', mother: '보호자◯', phone: '010-0000-0000',
  father: '보호자◯', dueDate: '0000-00-00', birthDate: '-', visit: 'Mock 유입경로',
}))
export const legacyPhotoScheduleTypes = ['촬영', '메이크업', '의상대여']
export const legacyPhotoScheduleProducts = ['Mock 촬영상품', 'Mock 메이크업상품', 'Mock 의상상품']
export const legacyPhotoScheduleWorkgroups = ['기존 작업담당 유지', 'Mock 촬영팀', 'Mock 편집팀']
